import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const errorMessage = () => {
    toast.error("Oops, something went wrong, please call Spaceways on (0800 1126 242)", {
        position: toast.POSITION.TOP_RIGHT
    });
}

export {errorMessage};